import React from 'react';

export function DetailRow({label, content, emptyText}) {
  const contentPresent = content != null && content !== '';

  return (
    <div>
      <p>
        <small>
          <strong>{label}</strong>
        </small>
      </p>
      <p>
        <small>{contentPresent ? content : <em>{emptyText}</em>}</small>
      </p>
    </div>
  );
}
